var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tariff-table-search app-main-content",
      attrs: { id: "tariff-table" }
    },
    [
      _c(
        "div",
        { ref: "detailsView", staticClass: "details-view" },
        [
          _c(
            "search-item",
            {
              key: 223201,
              ref: "tariffTable",
              attrs: {
                "show-simple": false,
                "expand-adv": true,
                reset: "",
                "retain-default-value": true,
                "config-module": "223201",
                "custom-search-items": _vm.customSearchItems,
                "grid-config-module": _vm.gridConfigModule
              },
              on: {
                perConfigChange: function(value) {
                  _vm.perConfigName = value
                },
                query: _vm.queryHandler
              }
            },
            [
              _c(
                "template",
                { slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        type: "primary",
                        no: "1",
                        title: _vm.$t("Pricing.ConfigureTheSurchargeTips")
                      },
                      on: { click: _vm.configureTheSurcharge }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.ConfigureTheSurcharge")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        no: "2",
                        title: _vm.$t("Pricing.TariffTableExportExcelTips")
                      },
                      on: { click: _vm.exportExcel }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ExcelExport")))]
                  ),
                  _c("cargo-advance-select", {
                    staticStyle: {
                      width: "115px",
                      display: "inline-block",
                      margin: "0px 5px"
                    },
                    attrs: {
                      no: "level",
                      filterable: "",
                      clearable: false,
                      "select-type":
                        _vm.selectTypeNames
                          .local_cache_PriceConstant$PRICE_LEVELS,
                      "default-value": _vm.filter.level
                    },
                    on: { parentCallBack: _vm.onLevelChanged }
                  })
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "tabs-container" },
            [
              _c(
                "el-tabs",
                {
                  ref: "tabs",
                  staticStyle: { width: "100%" },
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleTabClick },
                  model: {
                    value: _vm.tabName,
                    callback: function($$v) {
                      _vm.tabName = $$v
                    },
                    expression: "tabName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      key: 3,
                      attrs: {
                        lazy: true,
                        name: "AllFreightRates",
                        label: _vm.$t("CargoMsg.Cargo_All")
                      }
                    },
                    [
                      _c("div", { staticClass: "grid-view" }, [
                        _c("div", { staticClass: "main-content" }, [
                          _c(
                            "div",
                            { staticClass: "section grid-wrapper" },
                            [
                              _c("cargo-ag-grid", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "config-module": "22320104",
                                  "per-config-name": _vm.perConfigName,
                                  "grid-params": _vm.allGridParams,
                                  "grid-options": _vm.allGridOptions,
                                  "column-defs": _vm.allColumnDefs,
                                  "row-data": _vm.allRowData
                                },
                                on: {
                                  "update:gridParams": function($event) {
                                    _vm.allGridParams = $event
                                  },
                                  "update:grid-params": function($event) {
                                    _vm.allGridParams = $event
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "pagination-wrapper" },
                            [
                              _c("cargo-pagination", {
                                attrs: {
                                  total: _vm.all.total,
                                  "config-module": "22320104",
                                  page: _vm.all.pageNum,
                                  limit: _vm.all.pageSize,
                                  "page-count": _vm.all.pageCount
                                },
                                on: {
                                  "update:page": function($event) {
                                    return _vm.$set(_vm.all, "pageNum", $event)
                                  },
                                  "update:limit": function($event) {
                                    return _vm.$set(_vm.all, "pageSize", $event)
                                  },
                                  pagination: function() {
                                    if (_vm.all.total > 0) {
                                      _vm.queryHandler()
                                    }
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      key: 1,
                      attrs: {
                        lazy: true,
                        name: "TraditionalFreightRates",
                        label: _vm.$t("Pricing.TraditionalFreightRates")
                      }
                    },
                    [
                      _c("div", { staticClass: "grid-view" }, [
                        _c("div", { staticClass: "main-content" }, [
                          _c(
                            "div",
                            { staticClass: "section grid-wrapper" },
                            [
                              _c("cargo-ag-grid", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "config-module": "22320102",
                                  "per-config-name": _vm.perConfigName,
                                  "grid-params": _vm.traditionalGridParams,
                                  "grid-options": _vm.traditionalGridOptions,
                                  "column-defs": _vm.traditionalColumnDefs,
                                  "row-data": _vm.traditionalRowData
                                },
                                on: {
                                  "update:gridParams": function($event) {
                                    _vm.traditionalGridParams = $event
                                  },
                                  "update:grid-params": function($event) {
                                    _vm.traditionalGridParams = $event
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "pagination-wrapper" },
                            [
                              _c("cargo-pagination", {
                                attrs: {
                                  total: _vm.traditional.total,
                                  "config-module": "22320102",
                                  page: _vm.traditional.pageNum,
                                  limit: _vm.traditional.pageSize
                                },
                                on: {
                                  "update:page": function($event) {
                                    return _vm.$set(
                                      _vm.traditional,
                                      "pageNum",
                                      $event
                                    )
                                  },
                                  "update:limit": function($event) {
                                    return _vm.$set(
                                      _vm.traditional,
                                      "pageSize",
                                      $event
                                    )
                                  },
                                  pagination: function() {
                                    if (_vm.traditional.total > 0) {
                                      _vm.queryHandler()
                                    }
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      key: 2,
                      attrs: {
                        lazy: true,
                        name: "SpotFreightRates",
                        label: _vm.$t("Pricing.SpotFreightRates")
                      }
                    },
                    [
                      _c("div", { staticClass: "grid-view" }, [
                        _c("div", { staticClass: "main-content" }, [
                          _c(
                            "div",
                            { staticClass: "section grid-wrapper" },
                            [
                              _c("cargo-ag-grid", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "config-module": "22320103",
                                  "per-config-name": _vm.perConfigName,
                                  "grid-params": _vm.spotGridParams,
                                  "grid-options": _vm.spotGridOptions,
                                  "column-defs": _vm.spotColumnDefs,
                                  "row-data": _vm.spotRowData
                                },
                                on: {
                                  "update:gridParams": function($event) {
                                    _vm.spotGridParams = $event
                                  },
                                  "update:grid-params": function($event) {
                                    _vm.spotGridParams = $event
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "pagination-wrapper" },
                            [
                              _c("cargo-pagination", {
                                attrs: {
                                  total: _vm.spot.total,
                                  "config-module": "22320103",
                                  page: _vm.spot.pageNum,
                                  limit: _vm.spot.pageSize
                                },
                                on: {
                                  "update:page": function($event) {
                                    return _vm.$set(_vm.spot, "pageNum", $event)
                                  },
                                  "update:limit": function($event) {
                                    return _vm.$set(
                                      _vm.spot,
                                      "pageSize",
                                      $event
                                    )
                                  },
                                  pagination: function() {
                                    if (_vm.spot.total > 0) {
                                      _vm.queryHandler()
                                    }
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm.tabName !== "TraditionalFreightRates"
                ? _c(
                    "div",
                    {
                      class: _vm.tipWidth,
                      staticStyle: { position: "absolute", margin: "10px" }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("Pricing.SpotContainerWeightTips"))
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm.configureTheSurchargeDialog.visible
        ? _c("configure-the-surcharge-dialog", {
            ref: "configureTheSurchargeDialog",
            attrs: { visible: _vm.configureTheSurchargeDialog.visible },
            on: {
              onClose: function($event) {
                _vm.configureTheSurchargeDialog.visible = false
              },
              reload: _vm.reload
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }